/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { css } from "styled-components";
import Text from "../ui/Text";
import { useAssetsSrc } from "../../hooks/useAssetsSrc";
import { PAYMENT_PROCESSORS_ICONS_PATH } from "../../constants/constants";
import Icon from "../ui/Icon";
import { isActivationKey } from "../../hooks/a11y/activationKeys";

const StyledPaymentProcessorItem = styled.li`
  display: grid;
  text-align: center;
`;

const PaymentProcessorIconWrapper = styled.div`
  display: grid;
  place-items: center;
  min-height: 80px;
  gap: 0.5rem;
  padding: 0.5rem 1rem 1rem 1rem;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 1rem;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  @media (hover: hover) {
    &:hover {
      border-color: rgba(${({ theme }) => theme.colors.accent.rgba});
    }
  }

  ${(props) =>
    props.$selected &&
    css`
      border-color: rgba(${({ theme }) => theme.colors.accent.rgba});
      background: rgba(${({ theme }) => theme.colors.accent.rgb}, 0.1);
    `}
`;

const PaymentProcessorIcon = styled.img`
  && {
    max-width: 90px;
    margin: 0 auto; 
  }
`;

const PaymentProcessorItem = ({ processor, label, selected, onClick, rovingProps = {} }) => {
  const processorIcon = useAssetsSrc(`${PAYMENT_PROCESSORS_ICONS_PATH}${processor.name}.png`);

  const handleKeyDown = (e) => {
    rovingProps.onKeyDown?.(e);
    if (isActivationKey(e)) {
      e.preventDefault();
      onClick?.(e);
    }
  };

  return (
    <StyledPaymentProcessorItem
      ref={rovingProps.ref}
      role="radio"
      aria-checked={Boolean(selected)}
      tabIndex={rovingProps.tabIndex ?? 0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <PaymentProcessorIconWrapper $selected={selected}>
        {processor.name === "delay" && <Icon.PaymentProcessorDelay color="iconStroke" strokeWidth={1} size={Icon.SIZE.XXL} style={{paddingTop: "0.5rem"}}/>}
        {processor.name !== "delay" && <PaymentProcessorIcon src={processorIcon} alt="" />}
      </PaymentProcessorIconWrapper>
      <Text color="dark">{label ?? processor.name}</Text>
    </StyledPaymentProcessorItem>
  );
};

export default PaymentProcessorItem;
